class AnnouncementBarCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateItemsClass();
    this.showFirstItem();
    this.handleShowHide();
  }

  updateItemsClass() {
    const items = this.querySelectorAll('.announcement-bar__item');
    items.forEach(item => {
      const blockEl = item.closest('.shopify-block');
      const device = item.getAttribute('data-device') || 'desktop';
      blockEl.setAttribute('data-device', device);

      // 'both' means the same item renders on desktop AND mobile —
      // no hidden-* class is added so the merchant only needs ONE bar
      // for the typical case where the desktop and mobile layouts can
      // be handled with responsive CSS or per-child-block visibility
      // toggles (e.g. hide_on_mobile on a CTA button).
      if (device === 'desktop') {
        blockEl.classList.add('hidden-mobile');
      } else if (device === 'mobile') {
        blockEl.classList.add('hidden-desktop');
      }
    });
  }

  // Helper: items that participate in the desktop carousel rotation.
  _getDesktopItems() {
    return this.querySelectorAll('.shopify-block[data-device="desktop"], .shopify-block[data-device="both"]');
  }

  // Helper: items that participate in the mobile carousel rotation.
  _getMobileItems() {
    return this.querySelectorAll('.shopify-block[data-device="mobile"], .shopify-block[data-device="both"]');
  }

  showFirstItem() {
    const desktopItems = this._getDesktopItems();
    const mobileItems = this._getMobileItems();

    if (desktopItems.length > 0) {
      desktopItems[0].style.opacity = '1';
      desktopItems[0].style.visibility = 'visible';
    }

    if (mobileItems.length > 0) {
      mobileItems[0].style.opacity = '1';
      mobileItems[0].style.visibility = 'visible';
    }
  }

  handleShowHide() {
    const desktopItems = this._getDesktopItems();
    const mobileItems = this._getMobileItems();
    const carousel = this.querySelector('#announcement-bar');
    const buttons = Array.from(this.childNodes).filter(node => node.nodeName === 'BUTTON');

    if (desktopItems.length === 0) {
      carousel.classList.add('hidden-desktop');
    }
    if (mobileItems.length === 0) {
      carousel.classList.add('hidden-mobile');
    }

    if (desktopItems.length <= 1) {
      buttons.forEach(button => {
        button.classList.add('hidden-desktop');
      });
    }

    if (mobileItems.length <= 1) {
      buttons.forEach(button => {
        button.classList.add('hidden-mobile');
      });
    }
  }
}

if (!window.customElements.get("announcement-bar-carousel")) {
  window.customElements.define("announcement-bar-carousel", AnnouncementBarCarousel);
}